import { render, staticRenderFns } from "./BaseZeitraum.vue?vue&type=template&id=7673cb42&scoped=true"
import script from "./BaseZeitraum.vue?vue&type=script&lang=ts"
export * from "./BaseZeitraum.vue?vue&type=script&lang=ts"
import style0 from "./BaseZeitraum.vue?vue&type=style&index=0&id=7673cb42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7673cb42",
  null
  
)

export default component.exports